module.exports = __webpack_public_path__ + "img/img71.dbb79f60.png";